'use strict';
const angular = require('angular');
const {copy, forEach, isArray} = angular;

module.exports = [
  '$ionicActionSheet',
  ContextMenuServiceIonic];

function ContextMenuServiceIonic($ionicActionSheet) {
  var activeMenu;

  // ionic action sheet only supports 1 dangerous/important item... boo

  function IonicContextMenu(options) {
    Object.defineProperty(this, '$$deferred', {value: Promise.defer()});
    var self = this;
    var menuOptions = {
      buttons: [],
      titleText: options.titleText,
      cancelText: options.cancelText
    };

    var actions = [];

    forEach(options.actions, function (command) {
      if (command.important) {
        menuOptions.destructiveText = command.label;
        menuOptions.destructiveButtonClicked = function () {
          execute.call(self, command);
        }
      } else {
        actions.push(command);
        menuOptions.buttons.push({text: command.label});
      }
    });

    menuOptions.buttonClicked = function (index) {
      var command = actions[index];
      execute.call(self, command);
    };

    if (options.cancelFunction) {
      menuOptions.cancel = function () {
        options.cancelFunction();
        self.cancel();
      };
    } else {
      menuOptions.cancel = self.cancel.bind(self);
    }

    self.$$hideSheet = $ionicActionSheet.show(menuOptions);
  }

  IonicContextMenu.prototype.hide = function (value) {
    this.$$hideSheet();
    this.$$deferred.resolve(value);
  };

  IonicContextMenu.prototype.cancel = function (value) {
    this.$$hideSheet();
    this.$$deferred.reject(value);
  };

  function execute(command) {
    var self = this;
    var result;
    if (isArray(command.arguments)) {
      var args = copy(command.arguments);
      args.unshift(self);
      result = command.action.apply(command.context, args);
    } else {
      result = command.action.call(command.context, self);
    }

    if (result) {
      self.hide(result);
    } else {
      self.cancel(result);
    }
  }

  return {
    show: function (options) {
      if (activeMenu) {
        activeMenu.cancel();
      }

      activeMenu = new IonicContextMenu(options);
      return activeMenu.$$deferred.promise;
    },
    hide: function (value) {
      if (activeMenu) {
        activeMenu.hide(value);
        activeMenu = null;
      }
    },
    cancel: function (value) {
      if (activeMenu) {
        activeMenu.cancel(value);
        activeMenu = null;
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/js/core-components-implementation/context-menu/ContextMenuServiceIonic.js